module.exports = __webpack_public_path__ + "img/categorie-coquillages-famille-boutrais-small.be1b6068.jpg";